// src/api/auth.ts
import axios from './axios'; // ✅ 使用封装后的 axios 实例

// ✅ 注册请求
export const registerUser = async (email: string, password: string) => {
  try {
    const response = await axios.post('/register', {
      email,
      password,
    });
    return response.data;
  } catch (error: any) {
    console.error('❌ 注册失败:', error);
    throw error.response?.data || { detail: '登録に失敗しました。' };
  }
};

// ✅ 登录请求
export const loginUser = async (email: string, password: string) => {
  try {
    const response = await axios.post('/auth/login', {
      email,
      password,
    });
    return response.data;
  } catch (error: any) {
    console.error('❌ ログイン失敗:', error);
    throw error.response?.data || { detail: 'ログインに失敗しました。' };
  }
};

// ✅ 修改密码请求
export const changePassword = async (
  current_password: string,
  new_password: string,
  new_password_confirm: string
) => {
  try {
    const response = await axios.post('/auth/password/change', {
      current_password,
      new_password,
      new_password_confirm,
    });
    return response.data; // { access_token, token_type, message }
  } catch (error: any) {
    console.error('❌ パスワード変更失敗:', error);
    throw error.response?.data || { detail: 'パスワード変更に失敗しました。' };
  }
};
